import React from 'react';

const RuleEditorSummary = ({
  groupName,
  isActive,
  conditionCount,
  actionCount,
  priority
}) => (
  <section className="rule-editor-summary" aria-label="规则摘要">
    <header>
      <h2>规则摘要</h2>
    </header>
    <dl>
      <div>
        <dt>所属规则组</dt>
        <dd>{groupName}</dd>
      </div>
      <div>
        <dt>启用状态</dt>
        <dd>{isActive ? '启用' : '禁用'}</dd>
      </div>
      <div>
        <dt>条件数量</dt>
        <dd>{conditionCount}</dd>
      </div>
      <div>
        <dt>动作数量</dt>
        <dd>{actionCount}</dd>
      </div>
      <div>
        <dt>优先级</dt>
        <dd>{priority}</dd>
      </div>
    </dl>
  </section>
);

export default RuleEditorSummary;
